export * from './date';
export * from './currency';
export function leaveOnlyNumber() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.replace(/[^0-9]/g, '');
}